<template>
  <div class="app-shell">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'App',
};
</script>

<style>
.app-shell {
  min-height: 100vh;
  min-height: 100dvh;
  background: var(--color-background);
}
</style>
